var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipse1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 80,
    viewBox: "0 0 159 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159 0.5C159 10.9401 156.944 21.2779 152.948 30.9233C148.953 40.5687 143.097 49.3327 135.715 56.715C128.333 64.0972 119.569 69.9532 109.923 73.9484C100.278 77.9437 89.9401 80 79.5 80C69.0599 80 58.722 77.9437 49.0767 73.9484C39.4313 69.9532 30.6673 64.0972 23.285 56.715C15.9028 49.3327 10.0468 40.5687 6.05157 30.9233C2.05633 21.2779 -9.12701e-07 10.9401 0 0.499992H15.2943C15.2942 8.93161 16.955 17.2807 20.1816 25.0705C23.4083 32.8603 28.1376 39.9383 34.0997 45.9003C40.0617 51.8624 47.1397 56.5917 54.9295 59.8184C62.7193 63.045 71.0684 64.7057 79.5 64.7057C87.9316 64.7057 96.2807 63.045 104.07 59.8184C111.86 56.5917 118.938 51.8624 124.9 45.9003C130.862 39.9383 135.592 32.8603 138.818 25.0705C142.045 17.2807 143.706 8.93162 143.706 0.5H159Z",
    fill: "#F5821F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse1);
export default __webpack_public_path__ + "static/media/Ellipse 1.9f07d7c5aedad21749d18309b4700feb.svg";
export { ForwardRef as ReactComponent };